document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('h2.natural-flavors-heading-atdqym3roby94r3zcdaigenblocka5e7efbywdnrk').forEach(el => {
    const words = el.textContent.trim().split(' ');
    if (words.length < 2) return; // safety
    const last = words.pop();
    el.innerHTML = `${words.join(' ')} <span class="last-word">${last}</span>`;
  });
  document.querySelectorAll('.sustainOuter h2').forEach(el => {
    const words = el.textContent.trim().split(' ');
    if (words.length < 2) return; // safety
    const last = words.pop();
    el.innerHTML = `${words.join(' ')} <span class="last-word">${last}</span>`;
  });
  document.querySelectorAll('.event-title').forEach(el => {
    const words = el.textContent.trim().split(' ');
    if (words.length < 2) return; // safety
    const last = words.pop();
    el.innerHTML = `${words.join(' ')} <span class="last-word">${last}</span>`;
  });
});
